module.exports = __webpack_public_path__ + "static/troglodyte-3b68f793b1a83b1656199b200367baed.jpeg";